<nb-form-field>
    <nb-tag-list
        #tagsList
        (tagRemove)="onTagRemove($event)"
        class="pb-1 overflow-auto">
        @for (tag of tags; track tag) {
            <nb-tag
                [removable]="!disabled"
                [text]="tag"></nb-tag>
        }
        <input
            #inputRef
            (input)="onSearchChange()"
            (blur)="onBlur()"
            type="text"
            [disabled]="disabled"
            [(ngModel)]="search"
            [placeholder]="!tags.length ? placeholder : ''"
            nbTagInput
            (tagAdd)="onTagAdd($event.value)"
            [nbAutocomplete]="autocomplete"
            fullWidth
            kno2FormControl
            [containerId]="containerId"
            [status]="errors ? 'danger' : 'basic'"
            [required]="errors?.required || false" />
    </nb-tag-list>
</nb-form-field>

<nb-autocomplete
    #autocomplete
    (selectedChange)="onTagAdd($event)">
    @for (option of availableOptions | filterBy: ["selected"] : false; track option) {
        <nb-option [value]="option.value">
            {{ option.value }}
        </nb-option>
    }
</nb-autocomplete>
